import { useLayoutEffect } from "react";

/**
 * Locks the iframe document to the iframe viewport (see `global.css` `data-widget-iframe-layout`).
 * Prevents inner `min-height: 100vh` layouts from growing the iframe and the showcase shell.
 */
export function useFixedIframeDocumentLayout(enabled: boolean) {
  useLayoutEffect(() => {
    if (!enabled || typeof document === "undefined") {
      return;
    }

    document.documentElement.dataset.widgetIframeLayout = "fixed";

    return () => {
      delete document.documentElement.dataset.widgetIframeLayout;
    };
  }, [enabled]);
}
